(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6402);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9356:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/checked-green.7caf5014.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAklEQVR42mMAAeNdNZpGu2oOGuys/mW+q/YXkAaxNYGYgUEfyAAKvgPi/za76/9L7yj7r72z6r/Gzsp3ijvKNRlMgToZthX/Z9hW+JNha/5/tz1N/z/++Pxz593j/xk2Jh5kYNiS/WvDrYP/r766+z94X8f/t98+/AeB5l3z/zMsy/zFwLA179fSazv/w8C/f//+l2+f8Z9hWvh/xQWFvxnsdjccZNiU/n/ZtV0/f/z6+b9qxyyQ5E+NRcX/mRfkHmbQAzrSDOhIwR2l/y221PxnmJ3yX2Fh4X/WBbnv+RbmaTGAgAnQm5a76g7q7q7+pb+x4hfjvNxDgovytQQX5TMAAAVulCklhibJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 1186:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-dark-icon.af53ef32.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAATUlEQVR42j3NMQqAIABA0Td5raKgqNnw/kdQbHExQYg3/emTRYSBKJM0Jzg0CS7datHdELCpwz4rYFG9VrMcum3oToiaG1yahyL926R89ewWoHjqOHIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);





var Page = function(param) {
    var meta = param.meta, jsonLd = param.jsonLd, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    //! Url
    var url = "https://handle.am" + router.asPath;
    //! Title
    var title = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (meta === null || meta === void 0 ? void 0 : meta.title) || "Handle Brand Armenia";
    }, [
        meta === null || meta === void 0 ? void 0 : meta.title
    ]);
    //! Description
    var description = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (meta === null || meta === void 0 ? void 0 : meta.description) || "Handle Brand Armenia";
    }, [
        meta === null || meta === void 0 ? void 0 : meta.description
    ]);
    //! Image
    var image = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            url: (meta === null || meta === void 0 ? void 0 : meta.image) || "https://handle.am" + "/handle-logo.png",
            alt: title
        };
    }, [
        meta === null || meta === void 0 ? void 0 : meta.image
    ]);
    //! Ld Json
    var ldJson = jsonLd || {
        "@context": "http://schema.org/",
        "@type": "Organization",
        name: "Handle Brand Armenia",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Yerevan, Buzand 1/3",
            addressLocality: "Yerevan",
            addressRegion: "Yerevan"
        },
        telephone: "+374 33 58 58 50"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                canonical: url,
                type: "website",
                openGraph: {
                    url: url,
                    title: title,
                    description: description,
                    images: [
                        image
                    ]
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var Popup = function(props) {
    return props.trigger ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "popup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "popup-inner",
            children: props.children
        })
    }) : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (Popup);


/***/ }),

/***/ 9070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ productItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/icons/add-to-cart.png
/* harmony default export */ var add_to_cart = ({"src":"/_next/static/media/add-to-cart.72803f29.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAbUlEQVR42g3EIQ5BcQAH4F/AVMkJFFMpdNMEQbJJzEZAEJzBBYzgFC+9OYJ3oW/++7YvIjbeXuVIdMzVJkVtrhNbjcqtqDS2cXAyFTFztI+LpegWsXaPs5Voa4m+UVwtRGHoqRc7Xw8fJ2M/gz9GP1Mdk9tBnQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/icons/added-to-cart.png
/* harmony default export */ var added_to_cart = ({"src":"/_next/static/media/added-to-cart.d54ddace.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcklEQVR42h3NP8oBAAAH0N/69Y1GgwxiIya5gs2kDE6gLHaT2AxOYlDyd5EoGXGYl9I7wIuNo72ti7moxEdVQ1Pbn75H7BTlp+fuP9YmtmLgqaMWV7HwchNjyziLGCqIkWm8NbSU1JWtzGJjb+fk8Ku7X+TWWnrsh0F0AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/redux/global.slice.js
var global_slice = __webpack_require__(66);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./src/helpers/basket.helper.js
var basket_helper = __webpack_require__(8769);
// EXTERNAL MODULE: ./src/helpers/cookie.helpers.js
var cookie_helpers = __webpack_require__(2881);
;// CONCATENATED MODULE: ./src/components/productItem.js














var ProductItem = function(param) {
    var image = param.image, name = param.name, code = param.code, size = param.size, price = param.price, tag = param.tag, oldPriceData = param.oldPriceData, id = param.id, currency = param.currency, changeSize = param.changeSize, minPrice = param.minPrice, maxPrice = param.maxPrice;
    var ref, ref1;
    var ref2 = (0,react.useState)(null), sizeState = ref2[0], setSizeState = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(null), basketData = ref3[0], setBasketData = ref3[1];
    var intl = (0,useIntl/* default */.Z)();
    var priceData = price * tag;
    var priceOld = Math.round(priceData / 100);
    var newPrice = price - priceOld;
    var basket = (0,es/* useSelector */.v9)(function(state) {
        return state.global.basket;
    });
    var basketDataReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var basketReq, data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api/* basket_req */.Cl)(basket)
                        ];
                    case 1:
                        basketReq = _state.sent();
                        setBasketData(basketReq);
                        data = (0,cookie_helpers/* getCookie */.ej)("basket");
                        if (basketReq) {
                            dispatch((0,global_slice/* changeBasketCount */.zW)(data === null || data === void 0 ? void 0 : data.length));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function basketDataReq() {
            return _ref.apply(this, arguments);
        };
    }();
    var addBasket = function() {
        basketDataReq();
        (0,basket_helper/* addRemoveFromBasket */.cQ)(id, 1, intl.messages.product_successfully_added, intl.messages.product_successfully_removed);
    // const dataFilter = basketData?.find((item) => item.id === id);
    };
    (0,react.useEffect)(function() {
        if (typeof size === "string") {
            setSizeState(JSON.parse(size ? size : null));
        } else {
            setSizeState(size);
        }
    }, [
        size
    ]);
    var defaultImage = "https://via.placeholder.com/1000x1000/f3f3f3/f3f3f3/?text=.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-item mb-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-image",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: ("/product?id=".concat(id, "&changeSize=").concat(changeSize, "&minPrice=").concat(minPrice, "&maxPrice=").concat(maxPrice), "/product?id=".concat(id)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: defaultImage,
                                    alt: name
                                }),
                                tag > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tag",
                                    children: [
                                        "-",
                                        tag,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    }),
                    !basketData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "cart-button",
                        onClick: addBasket,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: intl.messages.addBasket
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: add_to_cart.src,
                                alt: "Add To Cart"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: intl.messages.productAdded
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: added_to_cart.src,
                                alt: ""
                            })
                        ]
                    })
                ]
            }),
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: "product-name mb-10",
                href: ("/product?id=".concat(id, "&changeSize=").concat(changeSize, "&minPrice=").concat(minPrice, "&maxPrice=").concat(maxPrice), "/product?id=".concat(id)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "product-name",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-ai-end flex-jc-between p-20 pl-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "product-info",
                            children: [
                                code && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        intl.messages.code,
                                        ": ",
                                        code
                                    ]
                                }),
                                (sizeState === null || sizeState === void 0 ? void 0 : (ref = sizeState[0]) === null || ref === void 0 ? void 0 : ref.name) || (sizeState === null || sizeState === void 0 ? void 0 : sizeState.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        intl.messages.size,
                                        ": ",
                                        (sizeState === null || sizeState === void 0 ? void 0 : (ref1 = sizeState[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || (sizeState === null || sizeState === void 0 ? void 0 : sizeState.name)
                                    ]
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-prices",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-price",
                                children: [
                                    tag ? newPrice : price,
                                    " ",
                                    currency
                                ]
                            }),
                            oldPriceData && price && tag > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-oldPrice",
                                children: [
                                    price,
                                    " ",
                                    currency
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var productItem = (ProductItem);


/***/ }),

/***/ 8511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var Title = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "title",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            children: title
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 8769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EG": function() { return /* binding */ incrementProduct; },
/* harmony export */   "Zg": function() { return /* binding */ decrementProduct; },
/* harmony export */   "cQ": function() { return /* binding */ addRemoveFromBasket; }
/* harmony export */ });
/* unused harmony export changeCountForProduct */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7582);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(977);
/* harmony import */ var _cookie_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2881);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2920);







function addRemoveFromBasket(id, count, addMessage, removeMessage) {
    var existingBasket = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("basket");
    if (!existingBasket) {
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify([
            id
        ]));
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, id, count)));
        react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(addMessage);
        return;
    }
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    try {
        existingBasket = JSON.parse(existingBasket);
        productsCount = JSON.parse(productsCount);
        var indexInBasket = existingBasket.indexOf(id);
        if (indexInBasket === -1) {
            productsCount[id] = count;
            existingBasket.push(id);
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify(existingBasket));
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(addMessage);
        } else {
            if (existingBasket.length === 1) {
                var basketDataReq = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        var basketReq, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        (0,_api_api__WEBPACK_IMPORTED_MODULE_0__/* .basket_req */ .Cl)(existingBasket)
                                    ];
                                case 1:
                                    basketReq = _state.sent();
                                    data = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("basket");
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function basketDataReq() {
                        return _ref.apply(this, arguments);
                    };
                }();
                basketDataReq();
                react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(removeMessage);
                (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
                (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
                window.location.reload();
                return;
            }
            delete productsCount[id];
            existingBasket.splice(indexInBasket, 1);
            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(removeMessage);
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify(existingBasket));
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
        }
    } catch (e) {
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
function incrementProduct(id) {
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    if (!productsCount) {
        return;
    }
    try {
        productsCount = JSON.parse(productsCount);
        productsCount[id]++;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
    } catch (e) {
        ;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
function decrementProduct(id) {
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    if (!productsCount) {
        return;
    }
    try {
        productsCount = JSON.parse(productsCount);
        productsCount[id]--;
        if (productsCount[id] === 0) {
            delete productsCount[id];
        }
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
    } catch (e) {
        ;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
var changeCountForProduct = function() {
    var countObj = _object_spread({}, state.productsCount);
    countObj[action.payload.productId] = action.payload.count;
    setCookie("productsCount", JSON.stringify(countObj));
    state.productsCount = countObj;
};


/***/ }),

/***/ 6402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./src/components/Page/index.js
var Page = __webpack_require__(7558);
;// CONCATENATED MODULE: ./src/components/categoryItem.js



var CategoryItem = function(param) {
    var id = param.id, title = param.title, description = param.description, image = param.image;
    var router = (0,next_router.useRouter)();
    var goTo = function() {
        router.push("/shop/1?&item=".concat(id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "category-item large flex flex-ai-end",
        onClick: goTo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: image,
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "category-item-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "category-name",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "category-description",
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var categoryItem = (CategoryItem);

// EXTERNAL MODULE: ./src/components/productItem.js + 2 modules
var productItem = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/elements/title.js
var title = __webpack_require__(8511);
// EXTERNAL MODULE: ./src/redux/main.slice.js
var main_slice = __webpack_require__(7382);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./src/components/popup.js
var popup = __webpack_require__(2324);
// EXTERNAL MODULE: ./src/assets/images/icons/checked-green.png
var checked_green = __webpack_require__(9356);
;// CONCATENATED MODULE: ./src/assets/images/icons/ban.png
/* harmony default export */ var ban = ({"src":"/_next/static/media/ban.fe3364ea.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAflBMVEX9ADr8ADr8ADnxADHmACflACfjACb/AD/rACvqACv7ADnnACj/AEH/AEHXABjXABj9ADrlACf/ADzhACP/ADzgACL9ADrlACf+ADvjACX8ADn8ADnlACflACf8ADnlACfxADHxADH9ADnlACf9ADrlACf8ADnlACfxADHxADFdeM2YAAAAKXRSTlMAAAAAAAAAAQICFhchIiIjKSo7PT9BcXOjpcLDw8TO0NHS5ebn6Ovt+pZ1K6AAAABISURBVHjaBUCFEYAgAHy7C5QwwCD3X9BDMivj9j7D/LK2EnGEYkjJI0+YNl0DrT1cRcKWdxaHuGleco0hyqbj34JsurzVS/EDu8QFS1JYAPMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/assets/images/icons/close-dark-icon.png
var close_dark_icon = __webpack_require__(1186);
;// CONCATENATED MODULE: ./src/pages/index.js

















// import OwlCarousel from "react-owl-carousel2";
// import "../../node_modules/react-owl-carousel2/lib/styles.css";
function Home() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var carouselRef = (0,react.useRef)();
    var orderId = router.query;
    // const [configState, setConfigState] = useState(null);
    var ref4 = (0,react.useState)(false), successPopup = ref4[0], setSuccessPopup = ref4[1];
    var ref5 = (0,react.useState)(null), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react.useState)(null), featured = ref6[0], setFeatured = ref6[1];
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.global.locale;
    });
    var configState = (0,es/* useSelector */.v9)(function(state) {
        return state.main.data;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var options = {
        items: 1,
        nav: true,
        rewind: true,
        autoplay: true,
        autoplayTimeout: 5000
    };
    // const configDataReq = async () => {
    //   const configData = await configsMain_req();
    //   dispatch(mainBlockData(configData));
    //   setConfigState(configData);
    // };
    var getFeatured = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api/* getFeautered_req */.i6)()
                        ];
                    case 1:
                        response = _state.sent();
                        setFeatured((ref = response.data) === null || ref === void 0 ? void 0 : ref.featuredProducts);
                        return [
                            2
                        ];
                }
            });
        });
        return function getFeatured() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFeatured();
    }, [
        locale
    ]);
    // const nardi = JSON?.parse(configState?.pinnedCategoryGroups?.[0]?.categories);
    // const shaxmat = JSON?.parse(
    //   configState?.pinnedCategoryGroups?.[1]?.categories
    // );
    var closePopup = function() {
        setSuccessPopup(!successPopup);
    };
    var arcaOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var arcaOrderData, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api/* arca_req */.yp)(orderId)
                        ];
                    case 1:
                        arcaOrderData = _state.sent();
                        if (arcaOrderData.data.success) {
                            setSuccessPopup(!successPopup);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        setError(e.response.data.message);
                        setSuccessPopup(!successPopup);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function arcaOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (orderId === null || orderId === void 0 ? void 0 : orderId.orderId) {
            arcaOrder();
        }
    }, [
        orderId
    ]);
    // useEffect(() => {
    //   configDataReq();
    // }, [locale]);
    // const contentBlock = configState?.sliderImages[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        meta: {
            title: "Շախմատների և Նարդիների Խանութսրահ | Handle.am",
            description: "Գնեք ամենաորակյալ շախմատները և նարդիները, փայտե ժամացույցները, խաղաքարերը, տակառները և հուշանվերները Handle.am - ից"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "home-page",
                className: "page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "main",
                        style: {
                            backgroundImage: "url(".concat(configState === null || configState === void 0 ? void 0 : configState.headerImage, ")")
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "main-content flex flex-ai-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: configState === null || configState === void 0 ? void 0 : (ref = configState.headerImageContent) === null || ref === void 0 ? void 0 : ref.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: configState === null || configState === void 0 ? void 0 : (ref1 = configState.headerImageContent) === null || ref1 === void 0 ? void 0 : ref1.text
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "categories pt-60 pb-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                    title: "".concat(intl.messages.products)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap flex-jc-between",
                                    children: configState === null || configState === void 0 ? void 0 : (ref2 = configState.pinnedCategories) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(categoryItem, {
                                            id: item.id,
                                            title: item.name,
                                            image: item.image,
                                            description: item.description
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products pt-40 pb-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                    title: "".concat(intl.messages.featuredCollections)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap",
                                    children: featured === null || featured === void 0 ? void 0 : featured.map(function(item, i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(productItem/* default */.Z, {
                                            image: item.image,
                                            name: item.title,
                                            size: item === null || item === void 0 ? void 0 : item.size,
                                            price: item.price,
                                            code: item.code,
                                            categoryName: item.categoryName,
                                            tag: item.tag,
                                            oldPriceData: false,
                                            id: item.id,
                                            currency: item.currency
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products pt-40 pb-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                    title: "".concat(intl.messages.discountedCollections)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap",
                                    children: configState === null || configState === void 0 ? void 0 : (ref3 = configState.productsWithDiscount) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(productItem/* default */.Z, {
                                            image: item.image,
                                            name: item.title,
                                            size: item.size,
                                            price: item.price,
                                            code: item.code,
                                            categoryName: item.categoryName,
                                            tag: item.discount,
                                            oldPriceData: true,
                                            id: item.id,
                                            currency: item.currency
                                        }, i);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* default */.Z, {
                trigger: successPopup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "close-button",
                            onClick: closePopup,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: close_dark_icon/* default.src */.Z.src,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "popup-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "payment-success",
                                    children: error ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: ban.src,
                                                alt: ""
                                            }),
                                            error
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: checked_green/* default.src */.Z.src,
                                                alt: ""
                                            }),
                                            intl.messages.paymentSuccessMessage
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "popup-buttons",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: closePopup,
                                        children: intl.messages.close
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);